module.exports = __webpack_public_path__ + "static/media/brain-heart.36af8a6a.svg";